import { render, staticRenderFns } from "./rebateManage.vue?vue&type=template&id=2484043c&scoped=true&"
import script from "./rebateManage.vue?vue&type=script&lang=js&"
export * from "./rebateManage.vue?vue&type=script&lang=js&"
import style0 from "./rebateManage.vue?vue&type=style&index=0&id=2484043c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2484043c",
  null
  
)

export default component.exports